import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CashiersStore {
  setCashiers(cashiers: any) {
    localStorage.setItem('cashiers', JSON.stringify(cashiers));
  }

  getCashiers() {
    return JSON.parse(localStorage.getItem('cashiers'));
  }

  setIsCashierAdded(added: boolean) {
    localStorage.setItem('isCashierAdded', added.toString());
  }

  getIsCashierAdded() {
    return localStorage.getItem('isCashierAdded');
  }

  setExistingCashiers(existingCashiers: any) {
    localStorage.setItem('existingCashiers', JSON.stringify(existingCashiers));
  }

  getExistingCashiers() {
    return JSON.parse(localStorage.getItem('existingCashiers'));
  }
}
